/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/track_optics_video_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./track_optics_video_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServiceClient =
  function TrackOpticsVideoServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServicePromiseClient =
  function TrackOpticsVideoServicePromiseClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest,
 *   !proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse>}
 */
const methodDescriptor_TrackOpticsVideoService_ListTrackOpticsVideos =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/ListTrackOpticsVideos",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListTrackOpticsVideosRequest,
    stronachgroup_first_racehorse360_messages_pb.ListTrackOpticsVideosResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListTrackOpticsVideosResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServiceClient.prototype.listTrackOpticsVideos =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/ListTrackOpticsVideos",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_ListTrackOpticsVideos,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServicePromiseClient.prototype.listTrackOpticsVideos =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/ListTrackOpticsVideos",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_ListTrackOpticsVideos
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest,
 *   !proto.stronachgroup.first.racehorse360.TrackOpticsVideo>}
 */
const methodDescriptor_TrackOpticsVideoService_GetTrackOpticsVideo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/GetTrackOpticsVideo",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetTrackOpticsVideoRequest,
    stronachgroup_first_racehorse360_messages_pb.TrackOpticsVideo,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.TrackOpticsVideo.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.TrackOpticsVideo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.TrackOpticsVideo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServiceClient.prototype.getTrackOpticsVideo =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/GetTrackOpticsVideo",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_GetTrackOpticsVideo,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.TrackOpticsVideo>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServicePromiseClient.prototype.getTrackOpticsVideo =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/GetTrackOpticsVideo",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_GetTrackOpticsVideo
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest,
 *   !proto.stronachgroup.first.racehorse360.TrackOpticsVideo>}
 */
const methodDescriptor_TrackOpticsVideoService_SubmitTrackOpticsVideo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/SubmitTrackOpticsVideo",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SubmitTrackOpticsVideoRequest,
    stronachgroup_first_racehorse360_messages_pb.TrackOpticsVideo,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.TrackOpticsVideo.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.TrackOpticsVideo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.TrackOpticsVideo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServiceClient.prototype.submitTrackOpticsVideo =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/SubmitTrackOpticsVideo",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_SubmitTrackOpticsVideo,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.TrackOpticsVideo>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServicePromiseClient.prototype.submitTrackOpticsVideo =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/SubmitTrackOpticsVideo",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_SubmitTrackOpticsVideo
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse>}
 */
const methodDescriptor_TrackOpticsVideoService_PullTrackOpticsVideoConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoConditions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullTrackOpticsVideoConditionsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullTrackOpticsVideoConditionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullTrackOpticsVideoConditionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServiceClient.prototype.pullTrackOpticsVideoConditions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoConditions",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_PullTrackOpticsVideoConditions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServicePromiseClient.prototype.pullTrackOpticsVideoConditions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoConditions",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_PullTrackOpticsVideoConditions
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest,
 *   !proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse>}
 */
const methodDescriptor_TrackOpticsVideoService_PullTrackOpticsVideoFileSignedUrl =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoFileSignedUrl",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullTrackOpticsVideoFileSignedUrlRequest,
    stronachgroup_first_racehorse360_messages_pb.PullTrackOpticsVideoFileSignedUrlResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullTrackOpticsVideoFileSignedUrlResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServiceClient.prototype.pullTrackOpticsVideoFileSignedUrl =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoFileSignedUrl",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_PullTrackOpticsVideoFileSignedUrl,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServicePromiseClient.prototype.pullTrackOpticsVideoFileSignedUrl =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/PullTrackOpticsVideoFileSignedUrl",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_PullTrackOpticsVideoFileSignedUrl
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_TrackOpticsVideoService_HandleTrackOpticsVideoPubsub =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrackOpticsVideoService/HandleTrackOpticsVideoPubsub",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.HandleTrackOpticsVideoPubsubRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServiceClient.prototype.handleTrackOpticsVideoPubsub =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/HandleTrackOpticsVideoPubsub",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_HandleTrackOpticsVideoPubsub,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrackOpticsVideoServicePromiseClient.prototype.handleTrackOpticsVideoPubsub =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrackOpticsVideoService/HandleTrackOpticsVideoPubsub",
      request,
      metadata || {},
      methodDescriptor_TrackOpticsVideoService_HandleTrackOpticsVideoPubsub
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
